export class HttpNoServerResponse extends Error {
}
